export default __webpack_public_path__ + "static/media/log-min.5deede6d.jpg";